import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonFunction } from 'src/app/helpers/commonFunction';
import { environment } from 'src/environments/environment';
import { AlertComponent } from '../../alert/alert.component';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
declare var $: any;
import * as _ from 'lodash';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { BankParticularsService } from 'src/app/services/bank-particulars.service';
@Component({
  selector: 'app-master-bank-particulars',
  templateUrl: './master-bank-particulars.component.html',
  styleUrls: ['./master-bank-particulars.component.css']
})
export class MasterBankParticularsComponent implements OnInit {

  public environmentSettings: any;
  id: any = null;

  // @ViewChild(DataTableDirective)
  // dtElements: QueryList<DataTableDirective>;
  // dtOptionsOfMasterDirector: DataTables.Settings = {};
  // dtOptionsOfRegisterDirector: DataTables.Settings = {};

  @ViewChild(DataTableDirective)
  dtElements: DataTableDirective;
  dtOptionsOfRegisterDirector: any = {};
  dtTriggerRegisterDirector: Subject<any> = new Subject();

  registerDirectorList: any[];
  deletebankdetails: any;
  masterDirectorList: any[];
  FromDateModelInMasterDirector: any;
  ToDateModelInMasterDirector: any;
  // dtTriggerMasterDirector: Subject<any> = new Subject();
  // dtTriggerRegisterDirector: Subject<any> = new Subject();
  error: any = { isError: false, errorMessage: '' };
  futureToDate: NgbDateStruct;
  futureToDateTo: NgbDateStruct;
  currentURL: any;
  response: boolean;
  nameOfBank: any;
  deletebankParticular: any;
  editParticularId: any;
  dateOfClose: any;
  dateOfOpen: any;
  isSearchDivVisible = false;

  constructor(private bankparticulars: BankParticularsService, private router: Router,
     private activatedRoute: ActivatedRoute, private commonFunction: CommonFunction, private alert: AlertComponent) {
    this.response = false;
  }

  ngOnInit() {

    this.environmentSettings = environment;
    let searchflag = localStorage.getItem('searchdireflag');
    // this.router.navigate(['/bankparticulars/edit/_id']);

    // this.router.navigate(['/bankparticulars/add']);
    this.dtOptionsOfRegisterDirector = {
      destroy: true,
      scrollY: "200px",
      scrollX: true,
      scrollCollapse: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      stateSave: true,
      stateDuration: -1,
      search: true,
      order: [0, 'asc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [15] }],
      dom: 'lBfrtip',//'Bfrtip',
      buttons: [
        {
          text: '<i class="fa fa-files-o"></i> Export to Excel',
          className: 'btn btn-sm btn-warning export-btn',
          filename: 'Bank Account Particular',
          title: 'Bank Account Particular',
          extend: 'excel',
          exportOptions: {
            columns: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 12, 14],
            format: {
              body: function ( data, row, column, node ) {
                  if(data.includes("+") || data.includes("@") || data.includes("=") || data.includes("|") || data.includes("!")){
                    if(data.match(/^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z0-9.-]+$/)){  return data }else{ return  "'" + data + "'"; }
                  }else{ return data }
                }
            }
          }

        }
      ]
    };
    this.getRegisterDirectorList();

    this.currentURL = window.location.href;


    var haseditpermisssion: any = false;
    if (this.currentURL.includes('edit') && !environment.PSS) {
      haseditpermisssion = this.commonFunction.validateURL('Director', 'edit');
    }
    else if (environment.PSS) {
      haseditpermisssion = this.commonFunction.validateURL('Director', 'add');
    }
    haseditpermisssion = false;

  }


  loadDetailsById(directorId) {
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['bankparticulars','edit']  } }],
      { relativeTo: this.activatedRoute.parent });
    // this.router.navigate(['/bankparticulars/edit/', directorId]);
  }
  add(){
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['bankparticulars','add']  } }],
      { relativeTo: this.activatedRoute.parent });
  }
  toggleSearchDiv() {
    this.isSearchDivVisible = !this.isSearchDivVisible;
  }
  confirmDelete(id) {
    this.deletebankParticular = id;
    $("#deleteConfirm").modal('toggle');
  }

  deletebankdetail() {
    this.bankparticulars.removedetails(this.deletebankParticular).subscribe(response => {
      var self = this;
      if (response.status == 0) {
        self.alert.success(response.message);
        $("#directormasterbankTable").DataTable().destroy();
        $('#deleteConfirm').modal('toggle');
      } else {
        self.alert.error(response.message);
      }
      this.getRegisterDirectorList();

    });
  }

  adjustdirectormasterTable() {
    setTimeout(() => {
      $("#directormasterbankTable").DataTable().columns.adjust().draw();
    }, 200);
  }

  tabRegisterOfDirectorOnClickEvent() {
    setTimeout(() => {
      $("#directormasterbankTable").DataTable().columns.adjust().draw();
    });
  }


  getRegisterDirectorList() {

    this.registerDirectorList = [];
    this.bankparticulars.getRegisterDirector({ isSearch: false }).subscribe(registerList => {
      this.registerDirectorList = registerList.data;
      console.log("this.registerDirectorList ",this.registerDirectorList )
      this.dtTriggerRegisterDirector.next();
      // setTimeout(() => {
      //   // $("#directormasterbankTable").DataTable().columns.adjust().draw();
      //   this.dtTriggerRegisterDirector.next();

      // }, 200);
    });
  }

  deletebank() {
    this.bankparticulars.removedetails(this.deletebankdetails)
      .subscribe(kmpshipRemove => {

      });

  }

  // redirectTobank() {
  //   this.activatedRoute.params.subscribe(params => {

  //     if (params['directorId'] != undefined) {
  //       this.router.navigate(['bankparticulars/add' + this.id]);
  //     }
  //     else {

  //     }

  //   })
  // }

  generateOutput() {
    let companyId = JSON.parse(localStorage.getItem('companyDetails')).companyID;
    var object = {
      id: null,
      fromDate: this.dateOfClose,
      toDate: this.dateOfOpen,
      name: this.nameOfBank
    }
    this.bankparticulars.generateBankAccountDocument(object).subscribe(response => {
      if (response.status == 0) {
        this.alert.success(response.message);
        var self = this;
        setTimeout(function () {
          self.downloadDocument(companyId);
          setTimeout(function () {
            self.downloadPdfDocument(companyId);
          }, 1000);
        }, 1000);
      } else {
        this.alert.error(response.message);
      }
    })
  }

  downloadDocument(id) {
    this.bankparticulars.downloadBankAccountFile(id, 'Multi');
  }
  downloadPdfDocument(id) {
    this.bankparticulars.downloadBankAccountPdfFile(id, 'Multi');
  }

  setDate(date) {
    if (date != "" && date != null) {
      return date.month + "-" + date.day + "-" + date.year;
    }
    return null;
  }
  doAdvSearch() {
    this.response = true;
    var searchParam =
    {
      "nameofthedocument": this.nameOfBank,
      "dateOfClose":this.setDate(this.dateOfClose),
      "dateOfOpen":this.setDate(this.dateOfOpen),

      'isSearch': true,
    };

    this.registerDirectorList = [];
    $("#directormasterbankTable").DataTable().destroy();
    this.bankparticulars.getRegisterDirector(searchParam).subscribe(registerList => {
      this.response = false;
      if (registerList.status == 0) {
        this.registerDirectorList = registerList.data;
        this.dtTriggerRegisterDirector.next();
      }
    });
  }
  clearAdvSearch() {
    this.nameOfBank = '';
    this.dateOfClose = undefined;
    this.dateOfOpen = undefined;
    $("#directormasterbankTable").DataTable().destroy();
    this.getRegisterDirectorList();
  }

}
